<template>
  <v-container fluid tag="section">
    <material-wizard
      v-model="tab"
      title="Nova Exportação de BDGD"
      subtitle="Selecione o mês e entidades que serão exportadas"
      :available-steps="tabsLiberadas"
      :tabs="tabs"
      class="mx-auto"
      :loading="loading"
      @click:next="next()"
      @click:prev="back()"
    >
      <exportar-bdgd-wizard-tabs ref="exportarBdgdParametros" :items="exportacoes" @step-observer="updateTabStatus($event)" />
    </material-wizard>
  </v-container>
</template>

<script>
  import ExportacoesBdgdsService from '@/services/ExportacoesBdgdsService';
  import wizardMixins from '@/mixins/wizardMixins';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      ExportarBdgdWizardTabs: () => import('@/components/geracao-bdgd/exportar-bdgd/ExportarBdgdWizardTabs'),
      MaterialWizard: () => import('@/components/base/MaterialWizard')
    },
    mixins: [wizardMixins],

    data: () => ({
      tabs: ['Mês dos Dados', 'Entidades', 'Confirmação'],
      loading: false,
      exportacoes: {}
    }),

    methods: {
      save() {
        const data = this.$refs.exportarBdgdParametros.exportData();
        this.loading = true;

        ExportacoesBdgdsService.save(data)
          .then(() => {
            this.$toast.success('Exportação de BDGD salva com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.replace({
              name: routes.state.appRoutes['EXPORTAR_BDGD_HISTORICO']
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar a Exportação de BDGD.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
